export enum TipoCombustible {
    Nafta= 1,
    GasOil= 2,
    Kerosene= 3,
}
